module.exports = __webpack_public_path__ + "images/hospital.svg?73d292845e0b64492eb2ef5b8ca44795";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hospital.svg
// module id = Ulrv
// module chunks = 0